import { render, staticRenderFns } from "./AdditionalInformationDialog.vue?vue&type=template&id=76e47f90&"
import script from "./AdditionalInformationDialog.vue?vue&type=script&lang=js&"
export * from "./AdditionalInformationDialog.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalInformationDialog.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports